<ng-template #clipMenu>
  <app-clip-menu [clipComponent]="this" ></app-clip-menu>
</ng-template>
<div class="clip {{ clip.cssClass }}" [ngClass]="{'active': isActive(), 'unlocked': clip.unlocked}" [ngbTooltip]="getTooltip()" container="body" [ngStyle]="getStyle()" (dblclick)="editClip(clip)" (touchstart)="mouseDown($event, clip)" (touchend)="mouseUp($event, clip)" (mousedown)="mouseDown($event, clip)" (mouseup)="mouseUp($event, clip)">
  <div class="grippy extend-left" *ngIf="!readonly" appExtendable [clipComponent]="this" [clip]="clip" [direction]="'left'">
    <span></span>
  </div>
  <div class="clip-content" (contextmenu)="onRightClick($event)">
    <div class="clip-image" *ngIf="clip.type === 'image'" [ngStyle]="{'background-image': 'url(' + clip.attachment.media.sizes.small.url + ')'}"></div>
    <div class="clip-text" *ngIf="clip.type === 'text'"></div>
    <div class="clip-speech-indicator" *ngIf="clip.type === 'speechindicator'"></div>
    <div class="clip-audiogram" *ngIf="clip.type === 'audiogram'"></div>
    <div class="clip-title">{{ clip.title }}</div>
    <div class="clip-menu" *ngIf="!readonly">
        <span class="fa fa-ellipsis-h toggle-points" id="clipMenu" [ngbPopover]="clipMenu" #p="ngbPopover" container="body"></span>
    </div>
  </div>
  <div class="grippy extend-right" *ngIf="!readonly" appExtendable [clipComponent]="this" [clip]="clip" [direction]="'right'">
    <span></span>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/timeline/video-layer/clip/clip.component.html